export const CReferencesModalFragments = {
  field: `
    fragment referencesModal on referencesModal_MatrixField {
      ... on referencesModal_block_Entry {
        id
        typeHandle
        heading
        copy
      }
    }
  `,
}
